import React from 'react';
import './Loading.css';
import { useStateValue } from './StateWrap';

// method that returns a spinning loading sign 
function Loading() {
    const [{ loadingDisplay }] = useStateValue();

    return (
        <div className="loading" style={{display: loadingDisplay === 'none' ? 'none' : 'flex'}}>
            <div className="loading_content">
                <div className="loading_spinner_container">
                    <span className="fa fa-spinner fa-3x"></span>
                </div>
                <div className="loading_text">Loading . . . </div>
            </div>
        </div>
    )
}

export default Loading;